import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

const SvgBk012 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.bk012_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "bk012_svg__a",
    d: "M0 7.5v1h22v-1ZM38 7.5v1h22v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 3a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-1a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z",
    transform: "translate(0 -2)",
    style: {
      fill: '#9f9f9f'
    }
  }));
};

const SvgBk022 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30 3a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-1a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z",
    transform: "translate(0 -2)",
    style: {
      fill: '#ff5722'
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0 8h60"
  }));
};

const SvgBk112 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 60",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.bk112_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "bk112_svg__a",
    d: "M7.5 60h1V38h-1ZM7.5 22h1V0h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-1a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z",
    transform: "translate(-2)",
    style: {
      fill: '#9f9f9f'
    }
  }));
};

const SvgBk122 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 23a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-1a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z",
    transform: "translate(20 -22)",
    style: {
      fill: '#ff5722'
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0 8h60"
  }));
};

const SvgBl012 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.05A7 7 0 0 0 2.05 12 7 7 0 0 0 12 2.05Z",
    style: {
      fill: '#ececec'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11 9.25h.79a.11.11 0 0 0 .1-.11v-4A.11.11 0 0 0 4.9 5h-.79a.11.11 0 0 0-.11.11v4a.11.11 0 0 0 .11.14Zm2.6-.66a.53.53 0 0 0 .53-.52.53.53 0 1 0-1.06 0 .53.53 0 0 0 .53.52Zm0-1.86a.53.53 0 0 0 .53-.52.53.53 0 1 0-1.06 0 .53.53 0 0 0 .53.52Zm1.81 2.52h.79a.11.11 0 0 0 .11-.11v-4A.11.11 0 0 0 9.31 5h-.79a.11.11 0 0 0-.11.11v4a.11.11 0 0 0 .11.14Z",
    style: {
      fill: '#9e9e9e'
    }
  }));
};

const SvgBl022 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.05A7 7 0 0 0 2.05 12 7 7 0 0 0 12 2.05Z",
    style: {
      fill: '#2878ff'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11 9.25h.79a.11.11 0 0 0 .1-.11v-4A.11.11 0 0 0 4.9 5h-.79a.11.11 0 0 0-.11.11v4a.11.11 0 0 0 .11.14Zm2.6-.66a.53.53 0 0 0 .53-.52.53.53 0 1 0-1.06 0 .53.53 0 0 0 .53.52Zm0-1.86a.53.53 0 0 0 .53-.52.53.53 0 1 0-1.06 0 .53.53 0 0 0 .53.52Zm1.81 2.52h.79a.11.11 0 0 0 .11-.11v-4A.11.11 0 0 0 9.31 5h-.79a.11.11 0 0 0-.11.11v4a.11.11 0 0 0 .11.14Z",
    style: {
      fill: '#fff'
    }
  }));
};

const SvgBlue2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.blue2_svg__a{fill:#4b8dff}')), /*#__PURE__*/React.createElement("path", {
    className: "blue2_svg__a",
    d: "M7 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4ZM10.54 8a5.07 5.07 0 0 1-6.83 0C2 8.92.23 10.76 0 12.43a.52.52 0 0 0 .1.38.6.6 0 0 0 .38.19h13a.53.53 0 0 0 .48-.57A6.94 6.94 0 0 0 10.54 8Z"
  }));
};

const SvgBx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 18",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.bx2_svg__a{fill:none;stroke:#4f4f4f}.bx2_svg__c{fill:#4f4f4f;fill-rule:evenodd}')), /*#__PURE__*/React.createElement("rect", {
    className: "bx2_svg__a",
    x: 4.83,
    y: 0.5,
    width: 11.67,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#4f4f4f'
    },
    d: "M0 2.33h1v13.33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bx2_svg__c",
    d: "M5.33 2.33v1.34H0V2.33h5.33zM5.33 14.33v1.34H0v-1.34h5.33z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bx2_svg__a",
    x: 4.83,
    y: 11.5,
    width: 11.67,
    height: 6,
    rx: 0.5
  }));
};

const SvgCharu12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.charu12_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "charu12_svg__a",
    d: "M5.6 3a.51.51 0 0 0 .4-.24l1.05-1.44 1.09 1.44a.57.57 0 0 0 .73.1.56.56 0 0 0 .13-.72L7.47.19a.59.59 0 0 0-.73-.1l-.1.1-1.51 2c0 .11-.15.21 0 .31a.46.46 0 0 0 .47.5ZM8 4H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1.09 1.09 0 0 0-1-1Zm0 8.93H6V5h2ZM13 0h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Zm0 9h-2V1h2ZM3 0H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1.05 1.05 0 0 0-1-1Zm0 9H1V1h2Z"
  }));
};

const SvgCharu22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.charu22_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "charu22_svg__a",
    d: "M3 4H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1.05 1.05 0 0 0 1-1V5a1 1 0 0 0-1-1Zm0 9H1V5h2ZM8 0H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1.09 1.09 0 0 0 1-1V1a1 1 0 0 0-1-1Zm0 9H6V1.08h2ZM8.14 11.24l-1.09 1.44L6 11.24a.51.51 0 0 0-.4-.24.46.46 0 0 0-.47.46c-.15.1 0 .2 0 .31l1.51 2 .1.1a.59.59 0 0 0 .73-.1l1.5-2a.56.56 0 0 0-.1-.72.57.57 0 0 0-.73.19ZM13 4h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm0 9h-2V5h2Z"
  }));
};

const SvgCrtb2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.crtb2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "crtb2_svg__a",
    d: "M16 3.75a3.75 3.75 0 0 0-7.5 0V7.5h3.75A3.75 3.75 0 0 0 16 3.75Zm-6.5 0v-.17a2.75 2.75 0 0 1 5.49.17v.17a2.75 2.75 0 0 1-2.75 2.58H9.5ZM0 12.25a3.75 3.75 0 1 0 7.5 0V8.5H3.75A3.75 3.75 0 0 0 0 12.25Zm6.5 0v.17A2.75 2.75 0 1 1 3.75 9.5H6.5ZM12.25 8.5H8.5v3.75a3.75 3.75 0 1 0 3.75-3.75ZM12.2 15a2.75 2.75 0 0 1-2.7-2.75V9.5h2.92a2.75 2.75 0 0 1-.22 5.49ZM3.75 0a3.75 3.75 0 0 0 0 7.5H7.5V3.75A3.76 3.76 0 0 0 3.75 0ZM6.5 6.5H3.58A2.751 2.751 0 0 1 3.75 1h.34A2.75 2.75 0 0 1 6.5 3.75Z"
  }));
};

const SvgCrtp2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.16 13.87",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.crtp2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "crtp2_svg__a",
    d: "M13.16 0H1.99a2 2 0 0 0-2 2.11v9.65a2.06 2.06 0 0 0 2 2.11h11.17a2.06 2.06 0 0 0 2-2.11V2.11a2 2 0 0 0-2-2.11Zm0 12.67H1.99a.88.88 0 0 1-.83-.91V8.61l3.2-3.35 3.21 4.35a1.13 1.13 0 0 0 1.57.26l2.34-1.7 2.55 1.32v2.27a.89.89 0 0 1-.87.91Zm.86-4.52-2-1a1.08 1.08 0 0 0-1.17.09l-2.3 1.64-3.26-4.39a1.14 1.14 0 0 0-.84-.46 1.09 1.09 0 0 0-.89.35l-2.4 2.61V2.11a.88.88 0 0 1 .86-.91h11.14a.88.88 0 0 1 .86.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crtp2_svg__a",
    d: "M11.03 2.41a1.55 1.55 0 0 0-1.5 1.6 1.5 1.5 0 1 0 3 0 1.55 1.55 0 0 0-1.5-1.6Zm0 2a.4.4 0 0 1 0-.79.4.4 0 0 1 0 .79Z"
  }));
};

const SvgCx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.69 18.4",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.79 7.2a1.7 1.7 0 0 0 1.7-1.7v-3a1.7 1.7 0 0 0-1.7-1.7H2.5A1.7 1.7 0 0 0 .8 2.5v3a1.7 1.7 0 0 0 1.7 1.7H7v5.6H2.5a1.7 1.7 0 0 0-1.7 1.7v3a1.7 1.7 0 0 0 1.7 1.7h10.29a1.7 1.7 0 0 0 1.7-1.7v-3a1.7 1.7 0 0 0-1.7-1.7H8.06V7.2Zm0 6.8a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h10.29ZM7 6H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h10.29a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H7Z",
    transform: "translate(-.8 -.8)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgDd12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.6 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12 2.9-.4-.9H4.5l-.5.9-2.8 5.6H3V14h10V8.5h1.8ZM7.2 3h1.6l1.5 4.5H5.7ZM2.8 7.5 5.1 3h1.1L4.6 7.5ZM12 13H4v-1h8Zm0-2H4V8.5h8Zm-.6-3.5L9.9 3H11l2.2 4.5Z",
    transform: "translate(-1.2 -2)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgDh12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.39 13.39",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.91 11.15-1.65-.92a.75.75 0 0 0-.7 0l-1.77.88a5 5 0 0 1-3.71-3.72L8 5.62a.75.75 0 0 0 0-.7L7 3.27a.75.75 0 0 0-.66-.39H4.47A1.39 1.39 0 0 0 3.11 4.7a18.11 18.11 0 0 0 3.71 6.67 18.19 18.19 0 0 0 6.66 3.7 1.39 1.39 0 0 0 1.82-1.36v-1.9a.77.77 0 0 0-.39-.66Z",
    transform: "translate(-2.48 -2.32)",
    style: {
      fill: '#fff',
      fillOpacity: 0.01,
      stroke: '#4f4f4f',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    }
  }));
};

const SvgDx12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.13 16.13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1A7.5 7.5 0 1 0 16 8.5 7.5 7.5 0 0 0 8.5 1Zm0 10.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z",
    transform: "translate(-.44 -.44)",
    style: {
      fill: 'none',
      stroke: '#4f4f4f',
      strokeWidth: '1.13px'
    }
  }));
};

const SvgDxk22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.38 1H2.13A1.12 1.12 0 0 0 1 2.13v11.25a1.12 1.12 0 0 0 1.13 1.12h11.25a1.12 1.12 0 0 0 1.12-1.12V2.13A1.12 1.12 0 0 0 13.38 1Zm-2.63 9.75h-6v-6h6Z",
    transform: "translate(-.44 -.44)",
    style: {
      fill: 'none',
      stroke: '#4f4f4f',
      strokeWidth: '1.13px'
    }
  }));
};

const SvgDz01 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.dz01_svg__a{fill:#4f4f4f}.dz01_svg__b{fill:none;stroke:#4f4f4f;stroke-miterlimit:10}')), /*#__PURE__*/React.createElement("path", {
    className: "dz01_svg__a",
    d: "M13.4 6.6h-1.9V5.4h1.9a.58.58 0 0 1 .6.6.58.58 0 0 1-.6.6ZM5.5 5.4h3v1.2h-3zM2.5 5.4v1.2H.6A.65.65 0 0 1 0 6a.65.65 0 0 1 .6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dz01_svg__b",
    d: "M12 8.5v-5a.47.47 0 0 0-.5-.5h-3a.47.47 0 0 0-.5.5v5a.47.47 0 0 0 .5.5h3a.47.47 0 0 0 .5-.5ZM2 11V1a.47.47 0 0 1 .5-.5h3A.47.47 0 0 1 6 1v10a.47.47 0 0 1-.5.5h-3A.47.47 0 0 1 2 11Z"
  }));
};

const SvgDz02 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.dz02_svg__a{fill:#4f4f4f}.dz02_svg__b{fill:none;stroke:#4f4f4f;stroke-miterlimit:10}')), /*#__PURE__*/React.createElement("path", {
    className: "dz02_svg__a",
    d: "M6.6.6v1.9H5.4V.6A.65.65 0 0 1 6 0a.65.65 0 0 1 .6.6ZM5.4 5.5h1.2v3H5.4zM5.4 11.5h1.2v1.9a.58.58 0 0 1-.6.6.65.65 0 0 1-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dz02_svg__b",
    d: "M8.5 2h-5a.47.47 0 0 0-.5.5v3a.47.47 0 0 0 .5.5h5a.47.47 0 0 0 .5-.5v-3a.47.47 0 0 0-.5-.5ZM11 12H1a.47.47 0 0 1-.5-.5v-3A.47.47 0 0 1 1 8h10a.47.47 0 0 1 .5.5v3a.47.47 0 0 1-.5.5Z"
  }));
};

const SvgEdit12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.9 11.9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.edit12_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "edit12_svg__a",
    d: "M9 3.9v7H1v-9h6v-1H0v11h10v-8H9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit12_svg__a",
    d: "M10.2 0h-.1L4.7 5.5l-.6.5.8.8.5-.6L10.9.8V.7l-.7-.7z"
  }));
};

const SvgEjcd2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.93 10.02",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 8.1 6.3 4a.67.67 0 0 0-1 0 .67.67 0 0 0 0 1l3.9 3.8-3.9 3.8a.67.67 0 0 0 0 1 .72.72 0 0 0 1 0l4.3-4.1a.75.75 0 0 0 .4-.7 1 1 0 0 0-.4-.7Z",
    transform: "translate(-5.07 -3.78)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgFc22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.38 1H2.13A1.12 1.12 0 0 0 1 2.13v11.25a1.12 1.12 0 0 0 1.13 1.12h11.25a1.12 1.12 0 0 0 1.12-1.12V2.13A1.12 1.12 0 0 0 13.38 1ZM11.5 8.13l-1.12 1.5-1.5-2.25L7 12.25 5.88 4l-1.5 4.13h0L5.88 4 7 12.25l1.88-4.87 1.5 2.25 1.12-1.5h0Z",
    transform: "translate(-.44 -.44)",
    style: {
      fill: 'none',
      stroke: '#4f4f4f',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    }
  }));
};

const SvgFile2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.file2_svg__a{fill:#fff;fill-opacity:.01}.file2_svg__c{fill:none;stroke:#4f4f4f;stroke-width:1.13px;stroke-linecap:round}')), /*#__PURE__*/React.createElement("path", {
    className: "file2_svg__a",
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "file2_svg__a",
    d: "M17 0H0v17h17V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 2h6.87L14 5.5v9.8a.69.69 0 0 1-.69.7H3.69a.69.69 0 0 1-.69-.7V2.7a.69.69 0 0 1 .69-.7Z",
    style: {
      strokeLinejoin: 'round',
      fill: 'none',
      stroke: '#4f4f4f',
      strokeWidth: '1.13px'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "file2_svg__c",
    d: "M6 6.18h4M8 6.18v6"
  }));
};

const SvgFws2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.02 12.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 7.2 8.7 3a.81.81 0 0 0-1.4 0L3.2 7.2a.67.67 0 0 0 0 1 .67.67 0 0 0 1 0L7.3 5v9.7a.7.7 0 0 0 1.4 0V5l3.1 3.2a.67.67 0 0 0 1 0 .73.73 0 0 0 0-1Z",
    transform: "translate(-2.98 -2.6)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgFwx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.02 12.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 9.7a.67.67 0 0 0-1 0L8.7 13V3.3a.7.7 0 1 0-1.4 0V13L4.2 9.8a.67.67 0 0 0-1 0 .73.73 0 0 0 0 1L7.3 15a1 1 0 0 0 .7.4.75.75 0 0 0 .7-.4l4.1-4.3a.67.67 0 0 0 0-1Z",
    transform: "translate(-3 -2.6)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgFwy2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.8 10.02",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14 8.3 9.8 4.2a.67.67 0 0 0-1 0 .67.67 0 0 0 0 1L12 8.3H2.3a.7.7 0 0 0 0 1.4H12l-3.2 3.1a.67.67 0 0 0 0 1 .72.72 0 0 0 1 0L14 9.7a1 1 0 0 0 .4-.7.75.75 0 0 0-.4-.7Z",
    transform: "translate(-1.6 -3.98)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgFwz2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.8 10.02",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.fwz2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "fwz2_svg__a",
    d: "M.4 4.3a.81.81 0 0 0 0 1.4l.6.57V3.71ZM12.1 4.3h-.3v1.4h.3a.7.7 0 0 0 0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fwz2_svg__a",
    d: "M11.8 4.3H2.4l3.2-3.1a.67.67 0 0 0 0-1 .73.73 0 0 0-1 0L1 3.71v2.56L4.7 9.8a.71.71 0 0 0 1-1L2.4 5.7h9.4Z"
  }));
};

const SvgFz2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.fz2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "fz2_svg__a",
    d: "M11.49 3.49H1a1 1 0 0 0-1 1V15a1 1 0 0 0 1 1h10.49a1 1 0 0 0 1-1V4.51a1 1 0 0 0-1-1Zm-.15 11.37H1.14V4.66h10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fz2_svg__a",
    d: "M15 0H4.51a1 1 0 0 0-1 1v1.6h1.15V1.14h10.2v10.25h-1.5v1.14h1.62a1 1 0 0 0 1-1V1A1 1 0 0 0 15 0Z"
  }));
};

const SvgGb12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.68 10.75",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#9f9f9f'
    },
    d: "M10.68.78 9.97.07l-4.6 4.6L.71 0 0 .71l4.67 4.66L0 10.04l.71.71 4.66-4.67 4.6 4.6.71-.71-4.6-4.6 4.6-4.59z"
  }));
};

const SvgGb22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.68 10.75",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#ff5722'
    },
    d: "M10.68.78 9.97.07l-4.6 4.6L.71 0 0 .71l4.67 4.66L0 10.04l.71.71 4.66-4.67 4.6 4.6.71-.71-4.6-4.6 4.6-4.59z"
  }));
};

const SvgGreen2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.green2_svg__a{fill:#73d29c}')), /*#__PURE__*/React.createElement("path", {
    className: "green2_svg__a",
    d: "M7 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4ZM10.54 8a5.07 5.07 0 0 1-6.83 0C2 8.92.23 10.76 0 12.43a.52.52 0 0 0 .1.38.6.6 0 0 0 .38.19h13a.53.53 0 0 0 .48-.57A6.94 6.94 0 0 0 10.54 8Z"
  }));
};

const SvgGs2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gs2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "gs2_svg__a",
    d: "M16 7.53V4.71h-5.37V0H5.27v4.71H0V16h11.29v-.94H4.71V16h-1v-.94H.94V8.47h14.12v6.59h-2.83V16H16V7.53Zm-15.06 0V5.65h5.27V.94h3.58v4.71h5.27v1.88H.94ZM16 8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gs2_svg__a",
    d: "M11.29 10.35h.94v4.71h-.94zM3.76 11.29h.94v3.76h-.94zM5.65 13.18h.94v1.88h-.94z"
  }));
};

const SvgHy22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 10.5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.hy22_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "hy22_svg__a",
    d: "M5.5 7A3.54 3.54 0 0 0 9 3.5V0H5.5A3.54 3.54 0 0 0 2 3.5 3.54 3.54 0 0 0 5.5 7Zm0-6H8v2.5A2.5 2.5 0 1 1 5.5 1ZM5.5 7.5c-3 0-5.4 1.3-5.5 3h1c.2-1 2-2 4.5-2s4.3 1 4.5 2h1c-.1-1.7-2.5-3-5.5-3Z"
  }));
};

const SvgJq2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.47 11.73H12.8v-8a.53.53 0 0 0-.53-.53h-8V.53a.54.54 0 0 0-1.07 0V3.2H.53a.54.54 0 0 0 0 1.07H3.2v8a.53.53 0 0 0 .53.53h8v2.67a.54.54 0 0 0 1.07 0V12.8h2.67a.54.54 0 0 0 0-1.07Zm-3.74 0H4.27V4.27h7.46Z",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgJs22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6V4.5A2.48 2.48 0 0 0 9 2H7a2.61 2.61 0 0 0-2 1 2.46 2.46 0 0 0-.5 1.5.47.47 0 0 0 .5.5.47.47 0 0 0 .5-.5A1.54 1.54 0 0 1 7 3h2a1.54 1.54 0 0 1 1.5 1.5V6h-6A1.54 1.54 0 0 0 3 7.5v5A1.54 1.54 0 0 0 4.5 14h7a1.54 1.54 0 0 0 1.5-1.5v-5A1.54 1.54 0 0 0 11.5 6Zm.5 6.5a.47.47 0 0 1-.5.5h-7a.47.47 0 0 1-.5-.5v-5a.47.47 0 0 1 .5-.5h7a.47.47 0 0 1 .5.5Z",
    transform: "translate(-3 -2)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgKjx012 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.kjx012_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "kjx012_svg__a",
    d: "M7.1 2a2.5 2.5 0 1 0 2.5 2.5A2.48 2.48 0 0 0 7.1 2Zm0 4a1.5 1.5 0 1 1 1.5-1.5A1.54 1.54 0 0 1 7.1 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kjx012_svg__a",
    d: "M14 4.2C13.9 4 10.9 0 7.1 0S.3 4 .2 4.2l-.2.3.2.3C.3 5 3.3 9 7.1 9s6.8-4 6.9-4.2l.2-.3ZM7.1 8C4.4 8 2 5.4 1.2 4.5 2 3.6 4.4 1 7.1 1s5.1 2.6 5.9 3.5C12.2 5.4 9.9 8 7.1 8Z"
  }));
};

const SvgKjx22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 10.62",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.kjx22_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "kjx22_svg__a",
    d: "M14 5.01c-.1-.2-3.1-4.2-6.9-4.2a4.48 4.48 0 0 0-2 .4l.7.8a5.07 5.07 0 0 1 1.3-.2c2.7 0 5.1 2.6 5.9 3.5a11.33 11.33 0 0 1-2.7 2.4l.6.8a14.78 14.78 0 0 0 3.1-2.9l.2-.3ZM7.1 8.81c-2.7 0-5.1-2.6-5.9-3.5a11.33 11.33 0 0 1 2.7-2.4l-.6-.8a14.78 14.78 0 0 0-3.1 2.9l-.2.3.2.3c.1.2 3.1 4.2 6.9 4.2a4.48 4.48 0 0 0 2-.4l-.7-.8a5.07 5.07 0 0 1-1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kjx22_svg__a",
    d: "M4.9 4.11a2.66 2.66 0 0 0-.3 1.2 2.48 2.48 0 0 0 2.5 2.5 2 2 0 0 0 .7-.1l-.8-.9a1.45 1.45 0 0 1-1.4-1.5v-.2ZM8.5 5.31a.37.37 0 0 1 .1.3l.7.9a2.38 2.38 0 0 0 .3-1.2 2.48 2.48 0 0 0-2.5-2.5 2 2 0 0 0-.7.1l.7.9a1.45 1.45 0 0 1 1.4 1.5ZM2.716.624 3.496 0l7.997 9.996-.78.624z"
  }));
};

const SvgKl2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.kl2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "kl2_svg__a",
    d: "M8.4 0v7.6H16V0Zm6.51 6.51H9.49V1.09h5.42ZM0 16h7.6V8.4H0Zm1.09-6.51h5.42v5.42H1.09ZM14.85 9.36a3.85 3.85 0 0 1-4 3.6v-1.33l-2.45 1.9 2.46 1.9V14.1h.25A5 5 0 0 0 16 9.14h-1.14ZM5.14 1.33h-.25A5 5 0 0 0 0 6.29h1.14v-.22a3.85 3.85 0 0 1 4-3.6V3.8L7.6 1.9 5.14 0Z"
  }));
};

const SvgLbgb2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#4f4f4f'
    },
    d: "M10 0 5.3 3.8.6 0 0 .8 5.3 5 10.6.8 10 0z"
  }));
};

const SvgLbsj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.lbsj2_svg__a{fill:none;stroke:#4f4f4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.13px}')), /*#__PURE__*/React.createElement("path", {
    className: "lbsj2_svg__a",
    d: "M.56 5.06V1.69A1.12 1.12 0 0 1 1.69.56h11.25a1.12 1.12 0 0 1 1.12 1.13v3.37M10.31 7.31v2.63M7.31 3.94v6M4.31 5.44v4.5M.56 9.56v3.38a1.12 1.12 0 0 0 1.13 1.12h11.25a1.12 1.12 0 0 0 1.12-1.12V9.56"
  }));
};

const SvgLbzk2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#4f4f4f'
    },
    d: "M5.3 0 0 4.2l.6.8 4.7-3.8L10 5l.6-.8L5.3 0z"
  }));
};

const SvgLink22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.13 10.13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.link22_svg__a{fill:none;stroke:#4f4f4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.13px}')), /*#__PURE__*/React.createElement("path", {
    className: "link22_svg__a",
    d: "M10.31 3.55H6.56a3 3 0 0 0 0 6h6a3 3 0 0 0 3-3 3 3 0 0 0-.75-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "link22_svg__a",
    d: "M1.31 5.55a3 3 0 0 1 2.25-5h6a3 3 0 0 1 0 6H5.81"
  }));
};

const SvgLj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.63 19.77",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.lj2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "lj2_svg__a",
    d: "M15.63 6.61a4.16 4.16 0 0 0-4.07-4.21H6a3 3 0 1 0 0 1.21h5.6a3 3 0 0 1 2.91 3 3 3 0 0 1-2.9 3H5.27a4.21 4.21 0 0 0 0 8.41H12v-1.2H5.27a3 3 0 0 1 0-6H12a4.16 4.16 0 0 0 3.63-4.21ZM4.67 3.7a1.8 1.8 0 1 1-.39-2 1.81 1.81 0 0 1 .39 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lj2_svg__a",
    d: "M13.08 15.26a.64.64 0 0 0-.65-.09.61.61 0 0 0-.34.55v3.44a.6.6 0 0 0 1 .47l2.06-1.7a.58.58 0 0 0 .22-.46.55.55 0 0 0-.21-.46Z"
  }));
};

const SvgLogo01 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.1 27.55",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.logo01_svg__a{fill:#014dff}.logo01_svg__b{fill:#ffb814}')), /*#__PURE__*/React.createElement("path", {
    className: "logo01_svg__a",
    d: "M20 18.17c0 .2-.1.3-.3.4l-7.4 4.3a.45.45 0 0 1-.5 0L8 20.77l-3.8-2.2-4.2-2.4v4.3c0 .2.1.3.3.4l11.5 6.6a.45.45 0 0 0 .5 0l11.5-6.6a.54.54 0 0 0 .3-.4v-4.3l-4.1-2.3ZM23.8 6.77 12.3.07a.45.45 0 0 0-.5 0L.3 6.77c-.2.1-.3.2-.3.4v4.3l4 2.4v-4.3c0-.2.1-.4.3-.4l7.5-4.3a.45.45 0 0 1 .5 0l3.7 2 3.8 2.2 4.2 2.4v-4.3c0-.2 0-.3-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo01_svg__b",
    d: "M16 16.18v-4.71l-2-1.09-2-1.2-4 2.29v4.71l2 1.09 2 1.21 4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo01_svg__b",
    d: "M16 16.18v-4.71l-2-1.09-2-1.2-4 2.29v4.71l2 1.09 2 1.21 4-2.3z"
  }));
};

const SvgLogo02 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 27.7",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.logo02_svg__a{fill:#014dff}')), /*#__PURE__*/React.createElement("path", {
    className: "logo02_svg__a",
    d: "M4 9.2v4.7l-4-2.4V6.9L12 0l12 6.9v4.6L12 4.6 4 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo02_svg__a",
    d: "m10 17.3-2-1.1v-4.7l4-2.3 2 1.2 2 1.1v4.7l-4 2.3-2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo02_svg__a",
    d: "M24 16.2v4.6l-12 6.9-12-6.9v-4.6l4 2.3 4 2.3 4 2.3 8-4.6v-4.6l4 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo02_svg__a",
    d: "M16 11.5v4.7l-4 2.3-2-1.2-2-1.1v-4.7l4-2.3 2 1.2 2 1.1z"
  }));
};

const SvgLogo03 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 2H3v16h8v-4a6 6 0 0 0 0-12Z",
    transform: "translate(-3 -2)",
    style: {
      fill: '#4361ee'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6H7v16h8v-4a6 6 0 0 0 0-12Z",
    transform: "translate(-3 -2)",
    style: {
      fill: '#4cc9f0'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v12h4v-4a6 6 0 0 0 6-6 4.67 4.67 0 0 0-.3-1.7A4.67 4.67 0 0 0 15 6Z",
    transform: "translate(-3 -2)",
    style: {
      fill: '#3a0ca3'
    }
  }));
};

const SvgLogo04 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22.9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.logo04_svg__a{fill:#2878ff}')), /*#__PURE__*/React.createElement("path", {
    className: "logo04_svg__a",
    d: "M4 8.55a1.05 1.05 0 0 1 .5-.9l5-2.9a.91.91 0 0 1 1 0l3.6 2.1 5.9 3.4v-4a1.05 1.05 0 0 0-.5-.9l-9-5.2a.91.91 0 0 0-1 0l-9 5.2a1.05 1.05 0 0 0-.5.9v2.5l4 2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.9a1.05 1.05 0 0 1-.5.9l-5 2.9a.91.91 0 0 1-1 0l-4.4-2.5-5.1-3v4a1.05 1.05 0 0 0 .5.9l9 5.2a.91.91 0 0 0 1 0l9-5.2a1.05 1.05 0 0 0 .5-.9v-2.5l-4-2.3Z",
    transform: "translate(-2 -.55)",
    style: {
      fill: '#1ec0ff'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo04_svg__a",
    d: "M12.7 10.25a.71.71 0 0 0-.3-.6l-2-1.2a.85.85 0 0 0-.7 0l-2 1.2a.6.6 0 0 0-.3.6v2.3a.71.71 0 0 0 .3.6l2 1.2a.85.85 0 0 0 .7 0l2-1.2a.6.6 0 0 0 .3-.6Z"
  }));
};

const SvgLogo05 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 27.7",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.logo05_svg__a{fill:#014dff}')), /*#__PURE__*/React.createElement("path", {
    className: "logo05_svg__a",
    d: "M4 9.2v4.7l-4-2.4V6.9L12 0l12 6.9v4.6L12 4.6 4 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo05_svg__a",
    d: "m10 17.3-2-1.1v-4.7l4-2.3 2 1.2 2 1.1v4.7l-4 2.3-2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo05_svg__a",
    d: "M24 16.2v4.6l-12 6.9-12-6.9v-4.6l4 2.3 4 2.3 4 2.3 8-4.6v-4.6l4 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#ffb814'
    },
    d: "M16 11.5v4.7l-4 2.3-2-1.2-2-1.1v-4.7l4-2.3 2 1.2 2 1.1z"
  }));
};

const SvgLogo06 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22.9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.logo06_svg__a{fill:#2878ff}')), /*#__PURE__*/React.createElement("path", {
    className: "logo06_svg__a",
    d: "M4 8.55a1.05 1.05 0 0 1 .5-.9l5-2.9a.91.91 0 0 1 1 0l3.6 2.1 5.9 3.4v-4a1.05 1.05 0 0 0-.5-.9l-9-5.2a.91.91 0 0 0-1 0l-9 5.2a1.05 1.05 0 0 0-.5.9v2.5l4 2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.9a1.05 1.05 0 0 1-.5.9l-5 2.9a.91.91 0 0 1-1 0l-4.4-2.5-5.1-3v4a1.05 1.05 0 0 0 .5.9l9 5.2a.91.91 0 0 0 1 0l9-5.2a1.05 1.05 0 0 0 .5-.9v-2.5l-4-2.3Z",
    transform: "translate(-2 -.55)",
    style: {
      fill: '#1ec0ff'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo06_svg__a",
    d: "M12.7 10.25a.71.71 0 0 0-.3-.6l-2-1.2a.85.85 0 0 0-.7 0l-2 1.2a.6.6 0 0 0-.3.6v2.3a.71.71 0 0 0 .3.6l2 1.2a.85.85 0 0 0 .7 0l2-1.2a.6.6 0 0 0 .3-.6Z"
  }));
};

const SvgMail2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.13 15.38",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.75v8.18a.79.79 0 0 1-.75.82H2.25a.79.79 0 0 1-.75-.82V6.75L9 11.63Z",
    transform: "translate(-.94 -.94)",
    style: {
      fill: 'none',
      stroke: '#4f4f4f',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: 'round',
      fill: 'none',
      stroke: '#4f4f4f',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    },
    d: "M.56 5.73 8.06.56l7.5 5.17"
  }));
};

const SvgMail3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.13 15.38",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.75v8.18a.79.79 0 0 1-.75.82H2.25a.79.79 0 0 1-.75-.82V6.75L9 11.63Z",
    transform: "translate(-.94 -.94)",
    style: {
      fill: 'none',
      stroke: '#4f4f4f',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: 'round',
      fill: 'none',
      stroke: '#4f4f4f',
      strokeLinejoin: 'round',
      strokeWidth: '1.13px'
    },
    d: "M.56 5.73 8.06.56l7.5 5.17"
  }));
};

const SvgPeple32 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.peple32_svg__a{fill:#fff;fill-opacity:.01;stroke:#4f4f4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.13px}')), /*#__PURE__*/React.createElement("circle", {
    className: "peple32_svg__a",
    cx: 7.31,
    cy: 3.19,
    r: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "peple32_svg__a",
    d: "M13.73 10.45a3 3 0 0 0-1.31-1.31 7.59 7.59 0 0 0-3.11-.32H5.36a7.59 7.59 0 0 0-3.16.32 3 3 0 0 0-1.31 1.31 7.45 7.45 0 0 0-.33 3.2v.45h13.5v-.45a7.45 7.45 0 0 0-.33-3.2Z"
  }));
};

const SvgPp2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.pp2_svg__a{fill:#2878ff}')), /*#__PURE__*/React.createElement("path", {
    className: "pp2_svg__a",
    d: "M7 0a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7Zm0 13a6 6 0 1 1 6-6 6 6 0 0 1-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pp2_svg__a",
    d: "M8 3H4v8h1V9h3a3 3 0 0 0 3-3 3 3 0 0 0-3-3Zm0 5H5V4h3a2 2 0 0 1 0 4Z"
  }));
};

const SvgPptext12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 21.1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.pptext12_svg__a{fill:#2878ff}.pptext12_svg__b{fill:#1ec0ff}')), /*#__PURE__*/React.createElement("path", {
    className: "pptext12_svg__a",
    d: "M0 21.1V6.7h.7v2.4a4.56 4.56 0 0 1 1.9-2 5.19 5.19 0 0 1 2.7-.7A5 5 0 0 1 9 7.9a5.2 5.2 0 0 1-3.7 8.9 4.84 4.84 0 0 1-2.6-.7 5 5 0 0 1-1.9-1.9v6.9Zm.6-9.4A4.48 4.48 0 0 0 2 14.9a4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3A4.48 4.48 0 0 0 5.2 7 4.48 4.48 0 0 0 2 8.4a4.53 4.53 0 0 0-1.4 3.3ZM16.4 16.2v.6a3.86 3.86 0 0 1-2.7-1.1 3.69 3.69 0 0 1-1.1-2.7V0h.7v13.1a2.79 2.79 0 0 0 .9 2.2 2.94 2.94 0 0 0 2.2.9ZM27.3 6.7v10h-.7v-2.5a4.56 4.56 0 0 1-1.9 2 5 5 0 0 1-2.7.7 5 5 0 0 1-3.7-1.5 5.23 5.23 0 0 1-1.6-3.7A4.85 4.85 0 0 1 18.3 8 5.14 5.14 0 0 1 22 6.5a5.3 5.3 0 0 1 2.7.8 3.84 3.84 0 0 1 1.8 2V6.7Zm-9.9 5a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.53 4.53 0 0 0-1.4 3.3ZM30.6 16.7h-.7v-10h.7v2a4 4 0 0 1 3.9-2.3 4 4 0 0 1 3.1 1.3 4.57 4.57 0 0 1 1.3 3.1v5.8h-.7v-5.8a4 4 0 0 0-1.1-2.7A3.27 3.27 0 0 0 34.5 7a4 4 0 0 0-2.7 1.1 3.57 3.57 0 0 0-1.2 2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext12_svg__b",
    d: "M51 21.1V6.7h.7v2.4a4.56 4.56 0 0 1 1.9-2 5.19 5.19 0 0 1 2.7-.7A5 5 0 0 1 60 7.9a5.2 5.2 0 0 1-3.7 8.9 4.84 4.84 0 0 1-2.6-.7 5 5 0 0 1-1.9-1.9v6.9Zm.7-9.4a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.18 4.18 0 0 0-1.4 3.3ZM67.4 16.2v.6a3.86 3.86 0 0 1-2.7-1.1 3.69 3.69 0 0 1-1.1-2.7V0h.7v13.1a2.79 2.79 0 0 0 .9 2.2 3.28 3.28 0 0 0 2.2.9ZM78.3 6.7v10h-.7v-2.5a4.56 4.56 0 0 1-1.9 2 5.41 5.41 0 0 1-6.4-.8 5.23 5.23 0 0 1-1.6-3.7A4.85 4.85 0 0 1 69.3 8 5.14 5.14 0 0 1 73 6.5a5.3 5.3 0 0 1 2.7.8 3.84 3.84 0 0 1 1.8 2V6.7Zm-9.8 5a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.18 4.18 0 0 0-1.4 3.3ZM81.7 16.7H81v-10h.7v2a4.41 4.41 0 0 1 7-1 4.57 4.57 0 0 1 1.3 3.1v5.8h-.7v-5.8a4 4 0 0 0-1.1-2.7A3.27 3.27 0 0 0 85.6 7a4 4 0 0 0-2.7 1.1 3.57 3.57 0 0 0-1.2 2.7v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext12_svg__a",
    d: "M41.8 15.3a5.78 5.78 0 0 0 2.8.8c1.8 0 3-.9 3-1.8 0-1.4-1.4-2.2-2.8-2.7-1.9-.7-3.3-1.1-3.3-2.5 0-1.7 1.5-2.8 3.4-2.8a4.49 4.49 0 0 1 2.7 1l-.5.5a4.61 4.61 0 0 0-2.2-.8c-1.7 0-2.7.9-2.7 2.1s1.2 1.2 2.6 1.8c1.8.7 3.4 1.7 3.4 3.3 0 1.9-2.4 2.5-3.8 2.5a8 8 0 0 1-3.3-.9Z"
  }));
};

const SvgPptext22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.2 27.7",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.pptext22_svg__a{fill:#014dff}.pptext22_svg__c{fill:#0364ff}')), /*#__PURE__*/React.createElement("path", {
    className: "pptext22_svg__a",
    d: "M0 6.9v4.6l4 2.4V9.2l8-4.6 12 6.9V6.9L12 0 0 6.9zM20 18.5l-8 4.6-4-2.3-4-2.3-4-2.3v4.6l12 6.9 12-6.9v-4.6l-4-2.3v4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#ff9d00'
    },
    d: "M16 16.2v-4.7l-2-1.1-2-1.2-4 2.3v4.7l2 1.1 2 1.2 4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext22_svg__c",
    d: "M41.8 9a5.86 5.86 0 0 0-3.1.9 6 6 0 0 0-2.2 2.3V9.3h-.8v17.1h.8v-8.1a5.66 5.66 0 0 0 2.3 2.3 5.86 5.86 0 0 0 3.1.9 6.15 6.15 0 0 0 6.2-6.2 6 6 0 0 0-1.8-4.4A5.83 5.83 0 0 0 41.8 9Zm3.9 10a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.43 5.43 0 0 1 0 7.7ZM51.4 16.9V1.4h-.8v15.5a4.08 4.08 0 0 0 1.3 3.2 4.63 4.63 0 0 0 3.2 1.3v-.7a3.63 3.63 0 0 1-2.6-1.1 3.69 3.69 0 0 1-1.1-2.7ZM67.1 12.2A4.87 4.87 0 0 0 65 9.8a6.2 6.2 0 0 0-3.2-.9 6.15 6.15 0 0 0-6.2 6.2 6.15 6.15 0 0 0 6.2 6.2 6.2 6.2 0 0 0 3.2-.9 5.65 5.65 0 0 0 2.2-2.4v2.9h.8V9.3h-.8v2.9ZM65.6 19a5.07 5.07 0 0 1-3.8 1.6A4.92 4.92 0 0 1 58 19a5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 4.92 4.92 0 0 1-1.6 3.8ZM76.6 9a4.7 4.7 0 0 0-4.6 2.7V9.3h-.8v11.8h.8v-6.9a4.48 4.48 0 0 1 1.4-3.2 4.38 4.38 0 0 1 3.2-1.3 4.16 4.16 0 0 1 3.1 1.3 4.22 4.22 0 0 1 1.3 3.2v6.9h.8v-6.9a5 5 0 0 0-1.5-3.7A5.14 5.14 0 0 0 76.6 9ZM102.3 9a5.86 5.86 0 0 0-3.1.9 5.38 5.38 0 0 0-2.2 2.3V9.3h-.8v17.1h.8v-8.1a5.66 5.66 0 0 0 2.3 2.3 5.86 5.86 0 0 0 3.1.9 6.15 6.15 0 0 0 6.2-6.2 6 6 0 0 0-1.8-4.4 6.13 6.13 0 0 0-4.5-1.9Zm3.8 10a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 4.92 4.92 0 0 1-1.6 3.8ZM111.9 16.9V1.4h-.8v15.5a4.08 4.08 0 0 0 1.3 3.2 4.63 4.63 0 0 0 3.2 1.3v-.7a3.63 3.63 0 0 1-2.6-1.1 3.34 3.34 0 0 1-1.1-2.7ZM127.6 12.2a4.87 4.87 0 0 0-2.1-2.4 6.2 6.2 0 0 0-3.2-.9 6.15 6.15 0 0 0-6.2 6.2 6.15 6.15 0 0 0 6.2 6.2 6.2 6.2 0 0 0 3.2-.9 5.65 5.65 0 0 0 2.2-2.4v2.9h.8V9.3h-.8v2.9Zm-1.5 6.8a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 5.73 5.73 0 0 1-1.6 3.8ZM140.7 10.5A5 5 0 0 0 137 9a4.7 4.7 0 0 0-4.6 2.7V9.3h-.8v11.8h.8v-6.9a4.48 4.48 0 0 1 1.4-3.2 4.38 4.38 0 0 1 3.2-1.3 4.16 4.16 0 0 1 3.1 1.3 4.22 4.22 0 0 1 1.3 3.2v6.9h.8v-6.9a5.14 5.14 0 0 0-1.5-3.7ZM88.8 14.3c-1.7-.7-2.9-.8-3-2.1S87 9.8 89 9.8a4.91 4.91 0 0 1 2.6.9l.6-.6A5.76 5.76 0 0 0 89 8.9c-2.3 0-4 1.3-4 3.3 0 1.6 1.6 2.1 3.9 2.9 1.6.5 3.3 1.5 3.3 3.2 0 1.1-1.5 2.1-3.6 2.1a7.58 7.58 0 0 1-3.3-.9l-.6.6a9 9 0 0 0 3.9 1.1c1.7 0 4.4-.8 4.4-2.9-.1-1.9-2-3.1-4.2-4Z"
  }));
};

const SvgPptext32 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.2 27.7",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.pptext32_svg__a{fill:#014dff}.pptext32_svg__b{fill:#2163ff}')), /*#__PURE__*/React.createElement("path", {
    className: "pptext32_svg__a",
    d: "M0 6.9v4.6l4 2.4V9.2l8-4.6 12 6.9V6.9L12 0 0 6.9zM20 18.5l-8 4.6-4-2.3-4-2.3-4-2.3v4.6l12 6.9 12-6.9v-4.6l-4-2.3v4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext32_svg__b",
    d: "M16 16.2v-4.7l-2-1.1-2-1.2-4 2.3v4.7l2 1.1 2 1.2 4-2.3zM41.8 9a5.86 5.86 0 0 0-3.1.9 6 6 0 0 0-2.2 2.3V9.3h-.8v17.1h.8v-8.1a5.66 5.66 0 0 0 2.3 2.3 5.86 5.86 0 0 0 3.1.9 6.15 6.15 0 0 0 6.2-6.2 6 6 0 0 0-1.8-4.4A5.83 5.83 0 0 0 41.8 9Zm3.9 10a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.43 5.43 0 0 1 0 7.7ZM51.4 16.9V1.4h-.8v15.5a4.08 4.08 0 0 0 1.3 3.2 4.63 4.63 0 0 0 3.2 1.3v-.7a3.63 3.63 0 0 1-2.6-1.1 3.69 3.69 0 0 1-1.1-2.7ZM67.1 12.2A4.87 4.87 0 0 0 65 9.8a6.2 6.2 0 0 0-3.2-.9 6.15 6.15 0 0 0-6.2 6.2 6.15 6.15 0 0 0 6.2 6.2 6.2 6.2 0 0 0 3.2-.9 5.65 5.65 0 0 0 2.2-2.4v2.9h.8V9.3h-.8v2.9ZM65.6 19a5.07 5.07 0 0 1-3.8 1.6A4.92 4.92 0 0 1 58 19a5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 4.92 4.92 0 0 1-1.6 3.8ZM76.6 9a4.7 4.7 0 0 0-4.6 2.7V9.3h-.8v11.8h.8v-6.9a4.48 4.48 0 0 1 1.4-3.2 4.38 4.38 0 0 1 3.2-1.3 4.16 4.16 0 0 1 3.1 1.3 4.22 4.22 0 0 1 1.3 3.2v6.9h.8v-6.9a5 5 0 0 0-1.5-3.7A5.14 5.14 0 0 0 76.6 9ZM102.3 9a5.86 5.86 0 0 0-3.1.9 5.38 5.38 0 0 0-2.2 2.3V9.3h-.8v17.1h.8v-8.1a5.66 5.66 0 0 0 2.3 2.3 5.86 5.86 0 0 0 3.1.9 6.15 6.15 0 0 0 6.2-6.2 6 6 0 0 0-1.8-4.4 6.13 6.13 0 0 0-4.5-1.9Zm3.8 10a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 4.92 4.92 0 0 1-1.6 3.8ZM111.9 16.9V1.4h-.8v15.5a4.08 4.08 0 0 0 1.3 3.2 4.63 4.63 0 0 0 3.2 1.3v-.7a3.63 3.63 0 0 1-2.6-1.1 3.34 3.34 0 0 1-1.1-2.7ZM127.6 12.2a4.87 4.87 0 0 0-2.1-2.4 6.2 6.2 0 0 0-3.2-.9 6.15 6.15 0 0 0-6.2 6.2 6.15 6.15 0 0 0 6.2 6.2 6.2 6.2 0 0 0 3.2-.9 5.65 5.65 0 0 0 2.2-2.4v2.9h.8V9.3h-.8v2.9Zm-1.5 6.8a5.07 5.07 0 0 1-3.8 1.6 4.92 4.92 0 0 1-3.8-1.6 5.22 5.22 0 0 1-1.6-3.8 5.28 5.28 0 0 1 1.6-3.9 5.22 5.22 0 0 1 3.8-1.6 5.07 5.07 0 0 1 3.8 1.6 5.28 5.28 0 0 1 1.6 3.9 5.73 5.73 0 0 1-1.6 3.8ZM140.7 10.5A5 5 0 0 0 137 9a4.7 4.7 0 0 0-4.6 2.7V9.3h-.8v11.8h.8v-6.9a4.48 4.48 0 0 1 1.4-3.2 4.38 4.38 0 0 1 3.2-1.3 4.16 4.16 0 0 1 3.1 1.3 4.22 4.22 0 0 1 1.3 3.2v6.9h.8v-6.9a5.14 5.14 0 0 0-1.5-3.7ZM88.8 14.3c-1.7-.7-2.9-.8-3-2.1S87 9.8 89 9.8a4.91 4.91 0 0 1 2.6.9l.6-.6A5.76 5.76 0 0 0 89 8.9c-2.3 0-4 1.3-4 3.3 0 1.6 1.6 2.1 3.9 2.9 1.6.5 3.3 1.5 3.3 3.2 0 1.1-1.5 2.1-3.6 2.1a7.58 7.58 0 0 1-3.3-.9l-.6.6a9 9 0 0 0 3.9 1.1c1.7 0 4.4-.8 4.4-2.9-.1-1.9-2-3.1-4.2-4Z"
  }));
};

const SvgPptext42 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 21.1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.pptext42_svg__a{fill:#2878ff}.pptext42_svg__b{fill:#1ec0ff}')), /*#__PURE__*/React.createElement("path", {
    className: "pptext42_svg__a",
    d: "M0 21.1V6.7h.7v2.4a4.56 4.56 0 0 1 1.9-2 5.19 5.19 0 0 1 2.7-.7A5 5 0 0 1 9 7.9a5.2 5.2 0 0 1-3.7 8.9 4.84 4.84 0 0 1-2.6-.7 5 5 0 0 1-1.9-1.9v6.9Zm.6-9.4A4.48 4.48 0 0 0 2 14.9a4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3A4.48 4.48 0 0 0 5.2 7 4.48 4.48 0 0 0 2 8.4a4.53 4.53 0 0 0-1.4 3.3ZM16.4 16.2v.6a3.86 3.86 0 0 1-2.7-1.1 3.69 3.69 0 0 1-1.1-2.7V0h.7v13.1a2.79 2.79 0 0 0 .9 2.2 2.94 2.94 0 0 0 2.2.9ZM27.3 6.7v10h-.7v-2.5a4.56 4.56 0 0 1-1.9 2 5 5 0 0 1-2.7.7 5 5 0 0 1-3.7-1.5 5.23 5.23 0 0 1-1.6-3.7A4.85 4.85 0 0 1 18.3 8 5.14 5.14 0 0 1 22 6.5a5.3 5.3 0 0 1 2.7.8 3.84 3.84 0 0 1 1.8 2V6.7Zm-9.9 5a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.53 4.53 0 0 0-1.4 3.3ZM30.6 16.7h-.7v-10h.7v2a4 4 0 0 1 3.9-2.3 4 4 0 0 1 3.1 1.3 4.57 4.57 0 0 1 1.3 3.1v5.8h-.7v-5.8a4 4 0 0 0-1.1-2.7A3.27 3.27 0 0 0 34.5 7a4 4 0 0 0-2.7 1.1 3.57 3.57 0 0 0-1.2 2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext42_svg__b",
    d: "M51 21.1V6.7h.7v2.4a4.56 4.56 0 0 1 1.9-2 5.19 5.19 0 0 1 2.7-.7A5 5 0 0 1 60 7.9a5.2 5.2 0 0 1-3.7 8.9 4.84 4.84 0 0 1-2.6-.7 5 5 0 0 1-1.9-1.9v6.9Zm.7-9.4a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.18 4.18 0 0 0-1.4 3.3ZM67.4 16.2v.6a3.86 3.86 0 0 1-2.7-1.1 3.69 3.69 0 0 1-1.1-2.7V0h.7v13.1a2.79 2.79 0 0 0 .9 2.2 3.28 3.28 0 0 0 2.2.9ZM78.3 6.7v10h-.7v-2.5a4.56 4.56 0 0 1-1.9 2 5.41 5.41 0 0 1-6.4-.8 5.23 5.23 0 0 1-1.6-3.7A4.85 4.85 0 0 1 69.3 8 5.14 5.14 0 0 1 73 6.5a5.3 5.3 0 0 1 2.7.8 3.84 3.84 0 0 1 1.8 2V6.7Zm-9.8 5a4.48 4.48 0 0 0 1.4 3.2 4.48 4.48 0 0 0 3.2 1.4 4.31 4.31 0 0 0 3.2-1.4 4.38 4.38 0 0 0 1.3-3.2 4.6 4.6 0 0 0-1.3-3.3 4.36 4.36 0 0 0-6.4 0 4.18 4.18 0 0 0-1.4 3.3ZM81.7 16.7H81v-10h.7v2a4.41 4.41 0 0 1 7-1 4.57 4.57 0 0 1 1.3 3.1v5.8h-.7v-5.8a4 4 0 0 0-1.1-2.7A3.27 3.27 0 0 0 85.6 7a4 4 0 0 0-2.7 1.1 3.57 3.57 0 0 0-1.2 2.7v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pptext42_svg__a",
    d: "M41.8 15.3a5.78 5.78 0 0 0 2.8.8c1.8 0 3-.9 3-1.8 0-1.4-1.4-2.2-2.8-2.7-1.9-.7-3.3-1.1-3.3-2.5 0-1.7 1.5-2.8 3.4-2.8a4.49 4.49 0 0 1 2.7 1l-.5.5a4.61 4.61 0 0 0-2.2-.8c-1.7 0-2.7.9-2.7 2.1s1.2 1.2 2.6 1.8c1.8.7 3.4 1.7 3.4 3.3 0 1.9-2.4 2.5-3.8 2.5a8 8 0 0 1-3.3-.9Z"
  }));
};

const SvgQbzx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12.14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5h-1.7c.1-.2.2-.5.3-.7a1.88 1.88 0 0 0-.3-1.5c-.7-.7-2-.5-2.9.5a1.38 1.38 0 0 0-.4.3c-.1-.1-.1-.2-.2-.2a3.32 3.32 0 0 0-1.4-1 1.88 1.88 0 0 0-1.5.3 1.35 1.35 0 0 0-.4 1.4 1.61 1.61 0 0 0 .3.9H2v4h2V14h8V8.5h2v-4ZM7.5 13H5V8.5h2.5Zm0-6.9v1.4H3v-2h4.5Zm0-1.8v.2H6a1.59 1.59 0 0 1-.5-1c0-.3 0-.5.1-.5a.37.37 0 0 1 .3-.1h.3a2.1 2.1 0 0 1 .8.6 3 3 0 0 1 .5.7Zm1-.1a3 3 0 0 1 .5-.7 1.73 1.73 0 0 1 1.2-.6c.1 0 .3 0 .3.1a.75.75 0 0 1 .1.5 2.66 2.66 0 0 1-.6 1H8.5ZM11 13H8.5V8.5H11Zm2-5.5H8.5v-2H13Z",
    transform: "translate(-2 -1.86)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgQq2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.7 15.1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 8.1c.5-.3.3-.5.2-1.1-.1-.4-.3-.6-.5-.6s-.2 0-.3.2l-.1.1V5A4.59 4.59 0 0 0 8 .5 4.59 4.59 0 0 0 3.3 5v1.5a.37.37 0 0 0-.3-.1c-.3 0-.4.2-.5.6s-.2.7 0 .9a5.42 5.42 0 0 0-.9 2.4c0 1.7.4 1.8.4 1.8s.4-.3.6-.6l.3-.3.1-.1.1.2a7.81 7.81 0 0 0 1.1 2c-.6.2-1 .6-1 1 0 .7 1.1 1.3 2.4 1.3a3.31 3.31 0 0 0 1.9-.5h1a3.31 3.31 0 0 0 1.9.5c1.3 0 2.4-.6 2.4-1.3 0-.4-.4-.8-1-1a5.85 5.85 0 0 0 1-1.7l.1-.2.1.1.3.3c.2.2.5.6.6.6s.4-.2.4-1.8a5.08 5.08 0 0 0-.9-2.5Z",
    transform: "translate(-1.6 -.5)",
    style: {
      fill: '#50c8fd'
    }
  }));
};

const SvgQr2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.qr2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "qr2_svg__a",
    d: "M4.76 8.93H1.99a1.85 1.85 0 0 0-1.85 1.85v2.77a1.85 1.85 0 0 0 1.85 1.85h2.77a1.85 1.85 0 0 0 1.87-1.85v-2.77a1.85 1.85 0 0 0-1.87-1.85Zm.65 4.62v.09a.64.64 0 0 1-.64.56H1.9a.64.64 0 0 1-.56-.64v-2.87a.64.64 0 0 1 .64-.56h2.87a.64.64 0 0 1 .56.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr2_svg__a",
    d: "M16 2.19A2.35 2.35 0 0 0 13.63.05H2.19A2.33 2.33 0 0 0 0 2.35V7.7a.6.6 0 0 0 1.2 0V2.35a1.11 1.11 0 0 1 .34-.81 1.14 1.14 0 0 1 .8-.33h11.43a1.15 1.15 0 0 1 1 1.14v11.43a1.14 1.14 0 0 1-1.13 1H8.28a.637.637 0 0 0 .09 1.27h5.44A2.34 2.34 0 0 0 16 13.71V2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr2_svg__a",
    d: "M11.38 7.78v.09a.627.627 0 0 0 1.25-.09V3.29a.59.59 0 0 0-.59-.51H7.52a.61.61 0 0 0-.51.6v.09a.59.59 0 0 0 .62.51h2.93L6.72 7.86l-.09.08a.59.59 0 0 0 .11.8.6.6 0 0 0 .81 0l3.81-3.86Z"
  }));
};

const SvgQrcode2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.qrcode2_svg__a{fill:#2878ff}')), /*#__PURE__*/React.createElement("path", {
    className: "qrcode2_svg__a",
    d: "M0 5h5V0H0Zm1-4h3v3H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qrcode2_svg__a",
    d: "M2 2h1v1H2zM6 0v5h5V0Zm4 4H7V1h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qrcode2_svg__a",
    d: "M8 2h1v1H8zM0 11h5V6H0Zm1-4h3v3H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qrcode2_svg__a",
    d: "M2 8h1v1H2zM10 7H9V6H6v5h1V8h1v1h3V6h-1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qrcode2_svg__a",
    d: "M8 10h1v1H8zM10 10h1v1h-1z"
  }));
};

const SvgRil22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.ril22_svg__b,.ril22_svg__c{fill:none;stroke:#4f4f4f;stroke-linejoin:round;stroke-width:1.13px}.ril22_svg__c{stroke-linecap:round}')), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#fff',
      fillOpacity: 0.01
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ril22_svg__b",
    d: "M1.88 7.13h14.25V15a.75.75 0 0 1-.75.75H2.63a.74.74 0 0 1-.75-.75ZM1.88 3.38a.75.75 0 0 1 .75-.75h12.75a.76.76 0 0 1 .75.75v3.75H1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ril22_svg__c",
    d: "M6 1.5v3M12 1.5v3M10.5 12.75h2.25M5.25 12.75H7.5M10.5 9.75h2.25M5.25 9.75H7.5"
  }));
};

const SvgSc2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.06 14.5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.sc2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "sc2_svg__a",
    d: "M4.92 4.93a.47.47 0 0 0-.47.47v5.87a.48.48 0 0 0 .47.47.47.47 0 0 0 .47-.47V5.4a.47.47 0 0 0-.47-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sc2_svg__a",
    d: "M14.55 1.83h-3.57v-.64A1.21 1.21 0 0 0 9.77 0H5.3a1.21 1.21 0 0 0-1.21 1.19v.64H.47a.47.47 0 1 0 0 .94h1.75v9.79a2 2 0 0 0 2 1.94h6.69a2 2 0 0 0 2-1.94V2.75h1.64a.47.47 0 0 0 .51-.42.46.46 0 0 0-.51-.5Zm-9.52-.64A.28.28 0 0 1 5.3.92h4.47a.27.27 0 0 1 .27.27v.64h-5Zm5.84 12.38H4.18a1 1 0 0 1-1-1V2.75h8.72v9.81a1 1 0 0 1-1.03 1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sc2_svg__a",
    d: "M10.13 4.93a.47.47 0 0 0-.47.47v5.87a.5.5 0 0 0 1 0V5.4a.47.47 0 0 0-.53-.47ZM7.55 4.93a.47.47 0 0 0-.47.47v5.87a.47.47 0 1 0 .94 0V5.4a.47.47 0 0 0-.47-.47Z"
  }));
};

const SvgSd22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6V4.5A2.48 2.48 0 0 0 9 2H7a2.48 2.48 0 0 0-2.5 2.5V6A1.54 1.54 0 0 0 3 7.5v5A1.54 1.54 0 0 0 4.5 14h7a1.54 1.54 0 0 0 1.5-1.5v-5A1.54 1.54 0 0 0 11.5 6Zm-6-1.5A1.54 1.54 0 0 1 7 3h2a1.54 1.54 0 0 1 1.5 1.5V6h-5Zm6.5 8a.47.47 0 0 1-.5.5h-7a.47.47 0 0 1-.5-.5v-5a.47.47 0 0 1 .5-.5h7a.47.47 0 0 1 .5.5Z",
    transform: "translate(-3 -2)",
    style: {
      fill: '#2878ff'
    }
  }));
};

const SvgSjx22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.sjx22_svg__a{fill:#2878ff}')), /*#__PURE__*/React.createElement("circle", {
    className: "sjx22_svg__a",
    cx: 4.5,
    cy: 12,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "sjx22_svg__a",
    d: "M7.9 0H1.1A1.11 1.11 0 0 0 0 1.1v11.8A1.11 1.11 0 0 0 1.1 14h6.8A1.11 1.11 0 0 0 9 12.9V1.1A1.11 1.11 0 0 0 7.9 0Zm0 13H1.1c-.1 0-.1 0-.1-.1V11h7Zm.1-3H1V3h7Zm0-8H1l.1-1h6.8C8 1 8 1 8 1.1Z"
  }));
};

const SvgSr2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.23 15.58",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.sr2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "sr2_svg__a",
    d: "M14.88 2.73 12.62.37a1.22 1.22 0 0 0-1.72 0L1.68 9.76a.55.55 0 0 0-.11.15v.11l-.06.19-.24.72-.46 1.47-.78 2.39a.61.61 0 0 0 .73.78l.77-.26 2.94-1 .8-.27.16-.06H5.55a.36.36 0 0 0 .15-.11l9.18-9.43a1.22 1.22 0 0 0 0-1.71ZM4.93 12.9l-.5.17-1.68.59-1.21.4.79-2.53.29-.87v-.12l6.45-6.61 2.33 2.33Zm7.32-7.52L9.92 3.05l1.79-1.83 2.3 2.36ZM7.31 14.37a.6.6 0 0 0 .62.6h5.48a.6.6 0 0 0 .61-.6v-.62H7.31Z"
  }));
};

const SvgTc12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.38 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.tc12_svg__a{fill:none;stroke:#4f4f4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.13px}')), /*#__PURE__*/React.createElement("path", {
    className: "tc12_svg__a",
    d: "M.56 1.31a.76.76 0 0 1 .75-.75h12.75a.76.76 0 0 1 .75.75v9a.76.76 0 0 1-.75.75H1.31a.76.76 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tc12_svg__a",
    d: "M.56 8.06a.76.76 0 0 1 .75-.75h12.75a.76.76 0 0 1 .75.75v2.25a.76.76 0 0 1-.75.75H1.31a.76.76 0 0 1-.75-.75ZM6.94 2.81l-1.5 1.88M9.19 3.56l-1.13 1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.69,
    cy: 9.19,
    r: 1,
    style: {
      fill: '#4f4f4f'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "tc12_svg__a",
    d: "m5.06 11.06-1.12 3h7.5l-1.13-3"
  }));
};

const SvgUp22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.up22_svg__c{fill:none;stroke:#4f4f4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.13px}'), /*#__PURE__*/React.createElement("mask", {
    id: "up22_svg__a",
    x: -1.69,
    y: -1.69,
    width: 18,
    height: 18,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#fff'
    },
    d: "M0 0h18v18H0z",
    transform: "translate(-1.69 -1.69)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: 'url(#up22_svg__a)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "up22_svg__c",
    d: "M.56 7.32v6.74h13.5V7.31M10.69 3.94 7.31.56 3.94 3.94M7.31 10.31V.56"
  })));
};

const SvgVip22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.2 14.3",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 1.5H3.8L.4 6 8 15.8 15.6 6Zm-.6 1 2.3 3h-2.7l-1.5-3Zm-4.4 0h1.4l1.5 3H5.8Zm-3 0h1.9l-1.5 3H2ZM2 6.5h2.6l2 5.9Zm3.7 0h4.6L8 13.4Zm3.7 5.9 2-5.9H14Z",
    transform: "translate(-.4 -1.5)",
    style: {
      fill: '#fab70b'
    }
  }));
};

const SvgWechat22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14.7",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.wechat22_svg__a{fill:#60c84d}')), /*#__PURE__*/React.createElement("path", {
    className: "wechat22_svg__a",
    d: "M12.7 4.3h.2A6.52 6.52 0 0 0 6.5 0C2.9 0 0 2.5 0 5.6a5 5 0 0 0 2.5 4.3l-.8 2.5 2.6-1.6a8.52 8.52 0 0 0 2.3.4h.3a4.53 4.53 0 0 1-.3-1.6c0-2.9 2.7-5.3 6.1-5.3ZM9 2.9a.86.86 0 0 1 .8.8.79.79 0 0 1-.8.8.86.86 0 0 1-.8-.8.86.86 0 0 1 .8-.8ZM4.1 4.5a.86.86 0 0 1-.8-.8.86.86 0 0 1 .8-.8.86.86 0 0 1 .8.8.79.79 0 0 1-.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wechat22_svg__a",
    d: "M18 9.4c0-2.4-2.2-4.3-4.9-4.5h-.4c-2.9 0-5.3 2-5.3 4.5v.7a1.93 1.93 0 0 0 .3 1 5.24 5.24 0 0 0 5 2.8 6.45 6.45 0 0 0 2-.3l2 1.1-.6-2A3.74 3.74 0 0 0 18 9.4ZM10.8 9a.65.65 0 0 1-.6-.6v-.2l.3-.4a.35.35 0 0 0 .2-.1.65.65 0 0 1 .6.6c0 .3-.1.7-.5.7Zm3.7 0a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6Z"
  }));
};

const SvgWeibo2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.weibo2_svg__a{fill:#fb6622}')), /*#__PURE__*/React.createElement("path", {
    className: "weibo2_svg__a",
    d: "M13.4 7.4c-.2-.1-.4-.1-.3-.5a1.9 1.9 0 0 0 0-1.8c-.6-.8-2.2-.8-4 0 0 0-.6.2-.4-.2a1.91 1.91 0 0 0-.2-2c-1-1-3.6 0-5.8 2.3C1 6.8 0 8.5 0 10.1c0 2.9 3.8 4.7 7.5 4.7 4.8 0 8.1-2.8 8.1-5a2.77 2.77 0 0 0-2.2-2.4Zm-6.3 6.1c-2.7.3-5.3-1-5.5-2.9s2-3.7 4.9-4 5.4 1 5.6 2.9-2 3.7-5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "weibo2_svg__a",
    d: "M7.6 7.9A3.11 3.11 0 0 0 4 9.5a2.17 2.17 0 0 0 1.4 3.1A3.09 3.09 0 0 0 9.2 11a2.26 2.26 0 0 0-1.6-3.1ZM6.4 11a1.39 1.39 0 0 1-1.5.4.68.68 0 0 1-.3-1.1A1.24 1.24 0 0 1 6 9.9a.71.71 0 0 1 .4 1.1Zm1.3-1a.48.48 0 0 1-.6.2c-.1 0-.2-.3-.1-.5s.4-.3.5-.2c.3.1.3.3.2.5ZM13.1 0h-.6a.65.65 0 0 0-.6.6.65.65 0 0 0 .6.6h.5a3.69 3.69 0 0 1 3.7 3.7 5 5 0 0 1-.2 1.2v.2a.65.65 0 0 0 .6.6h.2c.2-.1.4-.2.4-.5a4 4 0 0 0 .3-1.5A4.91 4.91 0 0 0 13.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "weibo2_svg__a",
    d: "M13.1 2.5h-.3a.56.56 0 0 0-.5.6.65.65 0 0 0 .6.6h.2a1.16 1.16 0 0 1 1.2 1.2.6.6 0 0 1-.1.4v.2a.65.65 0 0 0 .6.6.82.82 0 0 0 .6-.4v-.1a1.85 1.85 0 0 0 .2-.7 2.59 2.59 0 0 0-2.5-2.4Z"
  }));
};

const SvgWeidu2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 18",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.weidu2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "weidu2_svg__a",
    d: "M14.14 3.76 8.37.25a1.65 1.65 0 0 0-1.74 0L.86 3.76A1.83 1.83 0 0 0 0 5.32v7.46a1.83 1.83 0 0 0 .88 1.57l5.77 3.42a1.67 1.67 0 0 0 1.7 0l5.77-3.42a1.8 1.8 0 0 0 .88-1.57V5.32a1.83 1.83 0 0 0-.86-1.56Zm-.29 9a.6.6 0 0 1-.3.52l-5.77 3.44a.56.56 0 0 1-.56 0L1.45 13.3a.6.6 0 0 1-.3-.52V5.32a.61.61 0 0 1 .29-.52l5.77-3.51a.55.55 0 0 1 .58 0l5.77 3.51a.61.61 0 0 1 .29.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "weidu2_svg__a",
    d: "M11 6 7.44 8.14 3.92 6.05c-.66-.4-1.24.64-.57 1l3.59 2.17V14a.58.58 0 1 0 1.15 0V9.14L11.59 7c.67-.37.1-1.42-.59-1Z"
  }));
};

const SvgWjgl2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 5H8.7L7 3.3 6.7 3H2v10h12V5Zm0 7H3V4h3.3L8 5.7l.3.3H13Z",
    transform: "translate(-2 -3)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgWys2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15H2a.94.94 0 0 1-1-1V2a.94.94 0 0 1 1-1h22a.94.94 0 0 1 1 1v12a.94.94 0 0 1-1 1Z",
    style: {
      fill: '#fff'
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none',
      stroke: '#fe4a69',
      strokeMiterlimit: 10
    },
    d: "M1 15 25 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 1a.94.94 0 0 1 1 1v12a.94.94 0 0 1-1 1H2a.94.94 0 0 1-1-1V2a.94.94 0 0 1 1-1h22m0-1H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z",
    style: {
      fill: '#cfcfcf'
    }
  }));
};

const SvgXjzyx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16.2",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xjzyx2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "xjzyx2_svg__a",
    d: "M7.2 10.2c-.07 1.14 0 3.18 0 4.4v1a.19.19 0 0 0 .3 0 8.18 8.18 0 0 0 1.1-1l.8 1.6c.7-.4.1-.1.8-.5-.22-.55-.35-.85-.45-1.1s-.16-.37-.25-.6c.3 0 .8-.1 1.5-.1.1 0 0-.1-.1-.2ZM14 0H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm.8 8a.86.86 0 0 1-.8.8H2a.86.86 0 0 1-.8-.8V2a.86.86 0 0 1 .8-.8h12a.86.86 0 0 1 .8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xjzyx2_svg__a",
    d: "M4.9 4.3a.9.9 0 1 0 .9.9.9.9 0 0 0-.9-.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "xjzyx2_svg__a",
    cx: 8,
    cy: 5.2,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "xjzyx2_svg__a",
    d: "M11.2 4.3a.9.9 0 1 0 .9.9.9.9 0 0 0-.9-.9Z"
  }));
};

const SvgXx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.45 15.45",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "xx2_svg__a",
    d: "M3.01 6.52a.92.92 0 0 0 .87 1 .92.92 0 0 0 .84-1 .93.93 0 0 0-.87-1 .93.93 0 0 0-.84 1ZM11.88 6.52a.93.93 0 0 0-.87-1 .93.93 0 0 0-.86 1 .87.87 0 1 0 1.73 0ZM7.88 7.36a1 1 0 0 0 .44-.84.93.93 0 0 0-.87-1 .93.93 0 0 0-.87 1 1 1 0 0 0 .44.84.75.75 0 0 0 .86 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xx2_svg__a",
    d: "M13.72 0h-12A1.9 1.9 0 0 0-.02 2v9.73a1.89 1.89 0 0 0 1.74 2h2a.23.23 0 0 1 .21.24.23.23 0 0 1-.21.25.2.2 0 0 1-.17-.11.49.49 0 0 0-.73-.15.68.68 0 0 0-.13.84 1.22 1.22 0 0 0 1 .62h.03a1.36 1.36 0 0 0 1.24-1.46 1.38 1.38 0 0 0-1.18-1.44H1.72a.75.75 0 0 1-.7-.8v-9.7a.76.76 0 0 1 .7-.81h12a.76.76 0 0 1 .7.81v9.73a.75.75 0 0 1-.7.8H6.13a.61.61 0 0 0 0 1.21h7.59a1.89 1.89 0 0 0 1.74-2V2.02A1.9 1.9 0 0 0 13.72 0Z"
  }));
};

const SvgXz2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17.14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xz2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "xz2_svg__a",
    d: "M3.77 5.83a.62.62 0 0 0-.83.17.56.56 0 0 0-.06.44.63.63 0 0 0 .28.34L7.39 9.1v4.52a.61.61 0 0 0 1.21 0V9.11l4.24-2.3a.6.6 0 0 0 .28-.34.55.55 0 0 0-.06-.47.62.62 0 0 0-.83-.21L8 8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xz2_svg__a",
    d: "m15.7 4.08-7.4-4a.59.59 0 0 0-.6 0l-7.4 4a.55.55 0 0 0-.3.49v8a.56.56 0 0 0 .3.49l7.4 4a.64.64 0 0 0 .6 0l7.4-4a.55.55 0 0 0 .3-.49v-8a.55.55 0 0 0-.3-.49Zm-.91 8.16L8 15.92l-6.79-3.68V4.9L8 1.23l6.79 3.67Z"
  }));
};

const SvgYellow2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 8a4 4 0 0 0 2.83-6.83A4 4 0 1 0 7 8Zm7 4.43A6.94 6.94 0 0 0 10.54 8a5.07 5.07 0 0 1-6.83 0C2 8.92.23 10.76 0 12.43a.52.52 0 0 0 .1.38.6.6 0 0 0 .38.19h13a.53.53 0 0 0 .48-.57Z",
    style: {
      fill: '#ffad73'
    }
  }));
};

const SvgYftc2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.yftc2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "yftc2_svg__a",
    d: "M6 9H1V1h5v2h1V0H0v10h7V7H6v2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yftc2_svg__a",
    d: "M12 5 9 2.5v1.8H4v1.5h5v1.7L12 5z"
  }));
};

const SvgYjbd2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 4v8h12V4Zm10 1L9.2 7.3l-.8.7-.4.3-.4-.3-.8-.7L4 5Zm-9 .5L6 8l-3 2.5ZM4 11l2.8-2.4 1.2 1 1.2-1L12 11Zm9-.5L10 8l3-2.5Z",
    transform: "translate(-2 -4)",
    style: {
      fill: '#4f4f4f'
    }
  }));
};

const SvgYjsc2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.06 14.5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.yjsc2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "yjsc2_svg__a",
    d: "M14.55 1.83h-3.57v-.64A1.21 1.21 0 0 0 9.77 0H5.3a1.21 1.21 0 0 0-1.21 1.19v.64H.47a.47.47 0 1 0 0 .94h1.75v9.79a2 2 0 0 0 2 1.94h6.69a2 2 0 0 0 2-1.94V2.75h1.64a.47.47 0 0 0 .51-.42.46.46 0 0 0-.51-.5Zm-9.52-.64A.28.28 0 0 1 5.3.92h4.47a.27.27 0 0 1 .27.27v.64h-5Zm5.84 12.38H4.18a1 1 0 0 1-1-1V2.75h8.72v9.81a1 1 0 0 1-1.03 1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yjsc2_svg__a",
    d: "M4.92 4.93a.47.47 0 0 0-.47.47v5.87a.48.48 0 0 0 .47.47.47.47 0 0 0 .47-.47V5.4a.47.47 0 0 0-.47-.47ZM10.13 4.93a.47.47 0 0 0-.47.47v5.87a.5.5 0 0 0 1 0V5.4a.47.47 0 0 0-.53-.47ZM7.55 4.93a.47.47 0 0 0-.47.47v5.87a.47.47 0 1 0 .94 0V5.4a.47.47 0 0 0-.47-.47Z"
  }));
};

const SvgYouxianji = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.youxianji_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "youxianji_svg__a",
    d: "M10.43 12.83H8.79a.64.64 0 0 0-.66.63c0 .38.33.54.66.54h1.64a.62.62 0 0 0 .65-.62c0-.38-.32-.55-.65-.55ZM5.76.08a.53.53 0 0 0-.49 0 .17.17 0 0 0-.17.15L.18 4.9a.6.6 0 0 0 0 .86.72.72 0 0 0 .41.15.67.67 0 0 0 .41-.15L4.86 2.1v11.43a.69.69 0 0 0 .65.47.63.63 0 0 0 .66-.62V.62a.26.26 0 0 0-.09-.23C6 .23 5.92.08 5.76.08ZM15.34 0H8.79a.63.63 0 0 0-.66.62.59.59 0 0 0 .66.62h6.55A.63.63 0 0 0 16 .62a.63.63 0 0 0-.66-.62ZM12.07 8.56H8.79a.63.63 0 0 0-.66.62.59.59 0 0 0 .66.62h3.28a.62.62 0 1 0 0-1.24ZM13.71 4.28H8.79a.63.63 0 0 0-.66.62c0 .39.33.54.66.54h4.92a.63.63 0 0 0 .65-.62c0-.39-.36-.54-.65-.54Z"
  }));
};

const SvgZix22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.38 16.13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.zix22_svg__a,.zix22_svg__b{fill:none;stroke:#4f4f4f;stroke-linejoin:round;stroke-width:1.13px}.zix22_svg__a{stroke-linecap:round}')), /*#__PURE__*/React.createElement("path", {
    className: "zix22_svg__a",
    d: "M.56 8.06h14.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "zix22_svg__b",
    d: "M9.19.56h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.76.76 0 0 0 .75-.75v-3a.76.76 0 0 0-.75-.75ZM4.69 11.06h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.76.76 0 0 0 .75-.75v-3a.76.76 0 0 0-.75-.75ZM13.69 11.06h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.76.76 0 0 0 .75-.75v-3a.76.76 0 0 0-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "zix22_svg__a",
    d: "M7.69 8.06v-3M12.19 11.06v-3M3.19 11.06v-3"
  }));
};

const SvgZspp22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.zspp22_svg__a{fill:#ebaaff}')), /*#__PURE__*/React.createElement("path", {
    className: "zspp22_svg__a",
    d: "M10.54 8a5.07 5.07 0 0 1-6.83 0C2 8.92.23 10.76 0 12.43a.52.52 0 0 0 .1.38.6.6 0 0 0 .38.19h13a.53.53 0 0 0 .48-.57A6.94 6.94 0 0 0 10.54 8ZM7 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z"
  }));
};

const SvgZt2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.zt2_svg__a{fill:#4f4f4f}')), /*#__PURE__*/React.createElement("path", {
    className: "zt2_svg__a",
    d: "M9.48 11.8H2.84a.52.52 0 1 0 0 1h6.64a.52.52 0 1 0 0-1ZM4.72 2v-.44A.51.51 0 0 1 5.23 1a.51.51 0 0 0 .51-.47.54.54 0 0 0-.52-.53 1.56 1.56 0 0 0-1.53 1.56V2a.57.57 0 0 0 .14.36h.74A.53.53 0 0 0 4.72 2ZM15.48 4.79a.51.51 0 0 0-.51.52v2.07a.53.53 0 0 0 .51.51.51.51 0 0 0 .52-.51V5.31a.52.52 0 0 0-.52-.52ZM7.31 1h2.06a.52.52 0 0 0 0-1H7.31a.52.52 0 1 0 0 1ZM11.48 1h2.06a.52.52 0 0 0 0-1h-2.06a.52.52 0 1 0 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "zt2_svg__a",
    d: "M11.88 13.1a.51.51 0 0 1 .43-.5V3.94a1.54 1.54 0 0 0-1.55-1.55H4.57a.49.49 0 0 1-.37.16.52.52 0 0 1-.37-.16H1.55A1.54 1.54 0 0 0 0 3.94v10.51A1.54 1.54 0 0 0 1.55 16h9.21a1.54 1.54 0 0 0 1.55-1.55v-.85a.51.51 0 0 1-.43-.5Zm-.6 1.35a.52.52 0 0 1-.52.52H1.55a.52.52 0 0 1-.55-.52V3.94a.52.52 0 0 1 .52-.52h9.21a.52.52 0 0 1 .52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "zt2_svg__a",
    d: "M14.45 12.58h-2.14v1h2.14a.51.51 0 0 0 .55-.48.54.54 0 0 0-.55-.52ZM9.48 8.68H2.84a.52.52 0 1 0 0 1h6.64a.52.52 0 1 0 0-1ZM15 3.22a.53.53 0 0 0 .52.52.51.51 0 0 0 .48-.52V1.56a1.62 1.62 0 0 0-.11-.62.51.51 0 0 0-.65-.27.52.52 0 0 0-.27.68.37.37 0 0 1 0 .21ZM9.48 5.55H2.84a.52.52 0 1 0 0 1h6.64a.52.52 0 1 0 0-1ZM15.48 9a.51.51 0 0 0-.51.52v2.06a.53.53 0 0 0 .51.52.52.52 0 0 0 .52-.52V9.49a.52.52 0 0 0-.52-.49Z"
  }));
};

const SvgZx22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14h-11a.47.47 0 0 1-.5-.5v-11a.47.47 0 0 1 .5-.5h11a.47.47 0 0 1 .5.5v11a.47.47 0 0 1-.5.5Z",
    transform: "translate(-1.5 -1.5)",
    style: {
      fill: 'none',
      stroke: '#8c8c8c',
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: '#4f4f4f'
    },
    d: "M5 5h3v3H5z"
  }));
};

export { SvgBk012 as Bk012, SvgBk022 as Bk022, SvgBk112 as Bk112, SvgBk122 as Bk122, SvgBl012 as Bl012, SvgBl022 as Bl022, SvgBlue2 as Blue2, SvgBx2 as Bx2, SvgCharu12 as Charu12, SvgCharu22 as Charu22, SvgCrtb2 as Crtb2, SvgCrtp2 as Crtp2, SvgCx2 as Cx2, SvgDd12 as Dd12, SvgDh12 as Dh12, SvgDx12 as Dx12, SvgDxk22 as Dxk22, SvgDz01 as Dz01, SvgDz02 as Dz02, SvgEdit12 as Edit12, SvgEjcd2 as Ejcd2, SvgFc22 as Fc22, SvgFile2 as File2, SvgFws2 as Fws2, SvgFwx2 as Fwx2, SvgFwy2 as Fwy2, SvgFwz2 as Fwz2, SvgFz2 as Fz2, SvgGb12 as Gb12, SvgGb22 as Gb22, SvgGreen2 as Green2, SvgGs2 as Gs2, SvgHy22 as Hy22, SvgJq2 as Jq2, SvgJs22 as Js22, SvgKjx012 as Kjx012, SvgKjx22 as Kjx22, SvgKl2 as Kl2, SvgLbgb2 as Lbgb2, SvgLbsj2 as Lbsj2, SvgLbzk2 as Lbzk2, SvgLink22 as Link22, SvgLj2 as Lj2, SvgLogo01 as Logo01, SvgLogo02 as Logo02, SvgLogo03 as Logo03, SvgLogo04 as Logo04, SvgLogo05 as Logo05, SvgLogo06 as Logo06, SvgMail2 as Mail2, SvgMail3 as Mail3, SvgPeple32 as Peple32, SvgPp2 as Pp2, SvgPptext12 as Pptext12, SvgPptext22 as Pptext22, SvgPptext32 as Pptext32, SvgPptext42 as Pptext42, SvgQbzx2 as Qbzx2, SvgQq2 as Qq2, SvgQr2 as Qr2, SvgQrcode2 as Qrcode2, SvgRil22 as Ril22, SvgSc2 as Sc2, SvgSd22 as Sd22, SvgSjx22 as Sjx22, SvgSr2 as Sr2, SvgTc12 as Tc12, SvgUp22 as Up22, SvgVip22 as Vip22, SvgWechat22 as Wechat22, SvgWeibo2 as Weibo2, SvgWeidu2 as Weidu2, SvgWjgl2 as Wjgl2, SvgWys2 as Wys2, SvgXjzyx2 as Xjzyx2, SvgXx2 as Xx2, SvgXz2 as Xz2, SvgYellow2 as Yellow2, SvgYftc2 as Yftc2, SvgYjbd2 as Yjbd2, SvgYjsc2 as Yjsc2, SvgYouxianji as Youxianji, SvgZix22 as Zix22, SvgZspp22 as Zspp22, SvgZt2 as Zt2, SvgZx22 as Zx22 };
